<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h6 class="mb-0">
          <font-awesome-icon icon="check-circle" />
          {{ $t("status.title") }}
        </h6>
      </div>
      <div class="card-body">
        <div class="label">
          <div>{{ $tc('status.ig-found', nbCurrentIncidents, {nbIg: nbCurrentIncidents}) }}</div>
          <div>{{ $tc('status.tp-found', nbCurrentWorkplanned, {nbTp: nbCurrentWorkplanned}) }}</div>
        </div>
        <div class="national-incident" v-if="isNationalIncident">
          <div>{{ $t("status.ig-national")}}</div>
          <div>
            <span>{{ $t("status.link")}}</span>
            <a :href="travauxUrl">
              {{$t('status.travaux')}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusView",
  props: {
    nbCurrentIncidents: {
      type: Number,
    },
    nbCurrentWorkplanned: {
      type: Number,
    },
    isNationalIncident: {
      type: Boolean,
    },
  },
  data() {
    return {
      travauxUrl: "https://web-cloud.status-ovhcloud.com/",
    };
  },
};
</script>

<style>
.label {
  padding: 1rem;
}
.national-incident {
  padding: 1rem;
  background-color: #ECCACA;
  color: #803C3C;
}
</style>